export enum ProjectStatusEnum {
  active = 'active',
  cancel_draft = 'cancel_draft',
  pending_cancel_approval = 'pending_cancel_approval',
  canceled = 'canceled',
  completed = 'completed',
}
